import React from 'react';
import ReactDOM from 'react-dom';
import 'normalize.css';
import './index.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose } from 'redux';
import logger from 'redux-logger';
import promise from 'redux-promise-middleware';
import thunk from 'redux-thunk';
import rootReducer from './store/reducers/rootReducer';
import { BrowserRouter } from 'react-router-dom';
import ScrollToTop from '../src/components/ScrollToTop';

const composeEnhancers =
  process.env.NODE_ENV === 'development'
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : '' || compose;

const applyMiddlewareDev =
  process.env.NODE_ENV === 'development'
    ? applyMiddleware(promise, thunk, logger)
    : applyMiddleware(promise, thunk);

export const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddlewareDev)
);

const app = (
  <Provider store={store}>
    <BrowserRouter>
      <ScrollToTop>
        <App />
      </ScrollToTop>
    </BrowserRouter>
  </Provider>
);

ReactDOM.render(app, document.getElementById('root'));

/* if (module.hot) {
  module.hot.accept(app, () => {
    const NextApp = require(app).default;
    ReactDOM.render(NextApp, document.getElementById('root'));
  });
} */

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls. Learn
// more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
